(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
  class Carousel {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('.carousel__slide'));
      this.dots = Array.from(container.querySelectorAll('.carousel__dot'));
      this.currentSlide = 0;
      this.isTransitioning = false;
      this.autoplayInterval = 5000;
      this.autoplayTimer = null;

      this.touchStartX = 0; this.touchEndX = 0;
      this.touchStartY = 0; this.touchEndY = 0;
      this.minSwipeDistance = 50; this.isSwiping = false;

      this.init();
    }

    init() {
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          if (!this.isTransitioning && this.currentSlide !== index) {
            this.goToSlide(index);
            this.resetAutoplay();
          }
        });
      });

      const prevArrow = this.container.querySelector('.carousel__nav-arrow--prev');
      const nextArrow = this.container.querySelector('.carousel__nav-arrow--next');
      if (prevArrow) prevArrow.addEventListener('click', () => { this.prevSlide(); this.resetAutoplay(); });
      if (nextArrow) nextArrow.addEventListener('click', () => { this.nextSlide(); this.resetAutoplay(); });

      this.container.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.container.addEventListener('mouseleave', () => this.resumeAutoplay());

      this.initTouchHandlers();
      this.startAutoplay();

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseAutoplay();
        else this.resumeAutoplay();
      });
    }

    initTouchHandlers() {
      this.container.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
      this.container.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
      this.container.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });
      this.container.addEventListener('mousedown', (e) => this.handleMouseDown(e));
      this.container.addEventListener('mousemove', (e) => this.handleMouseMove(e));
      this.container.addEventListener('mouseup', (e) => this.handleMouseUp(e));
      this.container.addEventListener('mouseleave', (e) => this.handleMouseUp(e));
    }

    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.isSwiping = false;
      this.pauseAutoplay();
    }
    handleTouchMove(e) {
      if (!this.touchStartX) return;
      const x = e.touches[0].clientX, y = e.touches[0].clientY;
      const diffX = Math.abs(this.touchStartX - x), diffY = Math.abs(this.touchStartY - y);
      if (diffX > diffY && diffX > 10) { e.preventDefault(); this.isSwiping = true; }
    }
    handleTouchEnd(e) {
      if (!this.touchStartX || !this.isSwiping) { this.resumeAutoplay(); return; }
      this.touchEndX = e.changedTouches[0].clientX;
      this.handleSwipe(); this.resetTouchValues(); this.resumeAutoplay();
    }

    handleMouseDown(e) {
      if (e.button !== 0) return;
      this.touchStartX = e.clientX; this.touchStartY = e.clientY;
      this.isSwiping = false; this.container.style.cursor = 'grabbing'; this.pauseAutoplay(); e.preventDefault();
    }
    handleMouseMove(e) {
      if (!this.touchStartX) return;
      const diffX = Math.abs(this.touchStartX - e.clientX), diffY = Math.abs(this.touchStartY - e.clientY);
      if (diffX > diffY && diffX > 10) this.isSwiping = true;
    }
    handleMouseUp(e) {
      if (!this.touchStartX || !this.isSwiping) { this.container.style.cursor = ''; this.resumeAutoplay(); return; }
      this.touchEndX = e.clientX; this.handleSwipe(); this.resetTouchValues(); this.container.style.cursor = ''; this.resumeAutoplay();
    }

    handleSwipe() {
      const swipe = this.touchStartX - this.touchEndX;
      if (Math.abs(swipe) < this.minSwipeDistance) return;
      if (swipe > 0) this.nextSlide(); else this.prevSlide();
    }
    resetTouchValues() {
      this.touchStartX = 0; this.touchEndX = 0; this.touchStartY = 0; this.touchEndY = 0; this.isSwiping = false;
    }

    goToSlide(index) {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.slides.forEach(s => s.classList.remove('active','prev','next'));
      this.dots.forEach(d => d.classList.remove('active'));

      this.slides[index].classList.add('active');
      if (this.dots[index]) this.dots[index].classList.add('active');

      const prev = (index - 1 + this.slides.length) % this.slides.length;
      const next = (index + 1) % this.slides.length;
      if (this.slides[prev]) this.slides[prev].classList.add('prev');
      if (this.slides[next]) this.slides[next].classList.add('next');

      this.currentSlide = index;
      this.hideTouchHint();

      setTimeout(() => { this.isTransitioning = false; }, 500);
    }

    hideTouchHint() {
      const hint = this.container.querySelector('.carousel__touch-hint');
      if (hint) hint.style.display = 'none';
    }

    nextSlide() { if (!this.isTransitioning) this.goToSlide((this.currentSlide + 1) % this.slides.length); }
    prevSlide() { if (!this.isTransitioning) this.goToSlide((this.currentSlide - 1 + this.slides.length) % this.slides.length); }

    startAutoplay() { if (!this.autoplayTimer) this.autoplayTimer = setInterval(() => this.nextSlide(), this.autoplayInterval); }
    pauseAutoplay() { if (this.autoplayTimer) { clearInterval(this.autoplayTimer); this.autoplayTimer = null; } }
    resumeAutoplay() { if (!this.autoplayTimer) this.startAutoplay(); }
    resetAutoplay() { this.pauseAutoplay(); this.startAutoplay(); }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.carousel').forEach(c => new Carousel(c));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.initMegaMenuAutoClose();
    }

    initMegaMenuAutoClose() {
      const megaMenus = document.querySelectorAll('.mega-menu');
      
      // Funktion zum Schließen mit Animation
      const closeMegaMenu = (megaMenu) => {
        if (megaMenu.hasAttribute('open') && !megaMenu.classList.contains('closing')) {
          console.log('Closing mega menu'); // Debug
          megaMenu.classList.add('closing');
          setTimeout(() => {
            megaMenu.removeAttribute('open');
            megaMenu.open = false;
            megaMenu.classList.remove('closing');
            console.log('Mega menu closed'); // Debug
          }, 300);
        }
      };
      
      // Funktion zum Öffnen
      const openMegaMenu = (megaMenu) => {
        // Alle anderen schließen
        megaMenus.forEach(otherMenu => {
          if (otherMenu !== megaMenu) {
            closeMegaMenu(otherMenu);
          }
        });
        
        megaMenu.setAttribute('open', '');
        megaMenu.open = true;
        megaMenu.classList.remove('closing');
        console.log('Mega menu opened'); // Debug
      };
      
      megaMenus.forEach(megaMenu => {
        const summary = megaMenu.querySelector('summary');
        
        // Standard-Verhalten komplett überschreiben
        if (summary) {
          summary.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            if (megaMenu.hasAttribute('open')) {
              closeMegaMenu(megaMenu);
            } else {
              openMegaMenu(megaMenu);
            }
          });
        }
      });
      
      // Sehr aggressiver Mouse-Tracker
      let mouseTracker;
      
      const startMouseTracking = () => {
        if (mouseTracker) return;
        
        mouseTracker = setInterval(() => {
          const openMegaMenus = document.querySelectorAll('.mega-menu[open]:not(.closing)');
          
          if (openMegaMenus.length === 0) {
            clearInterval(mouseTracker);
            mouseTracker = null;
            return;
          }
          
                openMegaMenus.forEach(megaMenu => {
        const summary = megaMenu.querySelector('summary');
        const content = megaMenu.querySelector('.mega-menu__content');
        
        if (summary && content) {
          const summaryRect = summary.getBoundingClientRect();
          const contentRect = content.getBoundingClientRect();
          
          // Erweiterter Bereich mit Toleranzzone (30px für bessere Benutzerfreundlichkeit)
          const tolerance = 30;
          const totalArea = {
            left: Math.min(summaryRect.left, contentRect.left) - tolerance,
            right: Math.max(summaryRect.right, contentRect.right) + tolerance,
            top: Math.min(summaryRect.top, contentRect.top) - tolerance,
            bottom: Math.max(summaryRect.bottom, contentRect.bottom) + tolerance
          };
          
          // Mausposition
          const mouseX = window.lastMouseX || 0;
          const mouseY = window.lastMouseY || 0;
          
          // Ist Maus außerhalb?
          const isOutside = mouseX < totalArea.left || 
                           mouseX > totalArea.right || 
                           mouseY < totalArea.top || 
                           mouseY > totalArea.bottom;
          
          // Zusätzliche Prüfung: Ist die Maus auf dem Weg zum Content?
          const isMovingTowardsContent = mouseY > summaryRect.bottom - tolerance && 
                                       mouseY < contentRect.top + tolerance && 
                                       mouseX >= contentRect.left - tolerance && 
                                       mouseX <= contentRect.right + tolerance;
          
          // Debug-Informationen für verschiedene Menüpunkte
          const menuTitle = summary.textContent.trim();
          console.log(`Menu: ${menuTitle}, Mouse: (${mouseX}, ${mouseY}), Outside: ${isOutside}, MovingTowards: ${isMovingTowardsContent}`);
          
          if (isOutside && !isMovingTowardsContent) {
            console.log(`Closing menu: ${menuTitle} - Mouse outside and not moving towards content`);
            closeMegaMenu(megaMenu);
          }
        }
      });
        }, 100); // Weniger häufige Überprüfung für bessere Performance
      };
      
      // Mausposition verfolgen
      document.addEventListener('mousemove', (e) => {
        window.lastMouseX = e.clientX;
        window.lastMouseY = e.clientY;
        
        // Tracking starten wenn Menüs offen sind
        const openMegaMenus = document.querySelectorAll('.mega-menu[open]');
        if (openMegaMenus.length > 0) {
          startMouseTracking();
        }
      });
      
      // Backup: Klick außerhalb
      document.addEventListener('click', (e) => {
        const openMegaMenus = document.querySelectorAll('.mega-menu[open]');
        openMegaMenus.forEach(megaMenu => {
          if (!megaMenu.contains(e.target)) {
            closeMegaMenu(megaMenu);
          }
        });
      });
      
      // Backup: Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const openMegaMenus = document.querySelectorAll('.mega-menu[open]');
          openMegaMenus.forEach(closeMegaMenu);
        }
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-logos"] && !Shopify.designMode) return;
  try {
    
  class TestimonialLogos {
    constructor(container) {
      this.container = container;
      this.currentSlide = 0;
      this.isTransitioning = false;
      this.autoplayInterval = 5000;
      this.autoplayTimer = null;

      this.touchStartX = 0;
      this.touchEndX = 0;
      this.touchStartY = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 30;
      this.isSwiping = false;

      this.logoData = [];
      this.extractLogoData();
      this.init();
    }

    init() {
      this.updateActiveElements();
      this.updateMobileCarousel();
      this.initTouchHandlers();

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          if (!this.isTransitioning && this.currentSlide !== index) {
            this.goToSlide(index);
            this.resetAutoplay();
          }
        });
      });

      this.container.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.container.addEventListener('mouseleave', () => this.resumeAutoplay());

      if (window.innerWidth <= 749) this.startAutoplay();

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseAutoplay();
        else if (window.innerWidth <= 749) this.resumeAutoplay();
      });

      window.addEventListener('resize', () => {
        this.updateActiveElements();
        this.updateMobileCarousel();
        if (window.innerWidth <= 749) {
          if (!this.autoplayTimer) this.startAutoplay();
        } else {
          this.pauseAutoplay();
        }
      });
    }

    extractLogoData() {
      const logoBlocks = this.container.querySelectorAll('.testimonial-logos__slide--desktop .testimonial-logos__logo');
      this.logoData = Array.from(logoBlocks).map(logo => {
        const img = logo.querySelector('img');
        const link = logo.querySelector('a');
        const placeholder = logo.querySelector('div[style*="background"]');
        return {
          hasImage: !!img,
          src: img ? img.src : null,
          alt: img ? img.alt : null,
          width: img ? img.width : null,
          height: img ? img.height : null,
          link: link ? link.href : null,
          placeholder: placeholder ? placeholder.textContent : null,
          placeholderStyle: placeholder ? placeholder.getAttribute('style') : null
        };
      });
    }

    updateActiveElements() {
      if (window.innerWidth <= 749) {
        this.slides = Array.from(this.container.querySelectorAll('.testimonial-logos__slide--mobile'));
        this.dots = Array.from(this.container.querySelectorAll('.testimonial-logos__pagination--mobile .testimonial-logos__dot'));
      } else {
        this.slides = Array.from(this.container.querySelectorAll('.testimonial-logos__slide--desktop'));
        this.dots = Array.from(this.container.querySelectorAll('.testimonial-logos__pagination--desktop .testimonial-logos__dot'));
      }
    }

    updateMobileCarousel() {
      if (window.innerWidth > 749 || this.logoData.length === 0) return;

      const prevLogo = this.container.querySelector('#mobile-prev-logo');
      const currentLogo = this.container.querySelector('#mobile-current-logo');
      const nextLogo = this.container.querySelector('#mobile-next-logo');
      if (!prevLogo || !currentLogo || !nextLogo) return;

      const totalLogos = this.logoData.length;
      const prevIndex = (this.currentSlide - 1 + totalLogos) % totalLogos;
      const nextIndex = (this.currentSlide + 1) % totalLogos;

      this.updateLogoElement(prevLogo, this.logoData[prevIndex]);
      this.updateLogoElement(currentLogo, this.logoData[this.currentSlide]);
      this.updateLogoElement(nextLogo, this.logoData[nextIndex]);
    }

    updateLogoElement(element, logoData) {
      if (!element || !logoData) return;
      if (logoData.hasImage) {
        const content = logoData.link 
          ? `<a href="${logoData.link}" target="_blank" rel="noopener"><img src="${logoData.src}" alt="${logoData.alt}" loading="lazy" width="${logoData.width}" height="${logoData.height}"></a>`
          : `<img src="${logoData.src}" alt="${logoData.alt}" loading="lazy" width="${logoData.width}" height="${logoData.height}">`;
        element.innerHTML = content;
      } else {
        element.innerHTML = `<div style="${logoData.placeholderStyle}">${logoData.placeholder}</div>`;
      }
    }

    initTouchHandlers() {
      this.container.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
      this.container.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
      this.container.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });

      this.container.addEventListener('mousedown', (e) => this.handleMouseDown(e));
      this.container.addEventListener('mousemove', (e) => this.handleMouseMove(e));
      this.container.addEventListener('mouseup', (e) => this.handleMouseUp(e));
      this.container.addEventListener('mouseleave', (e) => this.handleMouseUp(e));
    }

    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.isSwiping = false;
      this.pauseAutoplay();
    }
    handleTouchMove(e) {
      if (!this.touchStartX) return;
      const touchCurrentX = e.touches[0].clientX;
      const touchCurrentY = e.touches[0].clientY;
      const diffX = Math.abs(this.touchStartX - touchCurrentX);
      const diffY = Math.abs(this.touchStartY - touchCurrentY);
      if (diffX > diffY && diffX > 10) {
        e.preventDefault();
        this.isSwiping = true;
      }
    }
    handleTouchEnd(e) {
      if (!this.touchStartX || !this.isSwiping) {
        if (window.innerWidth <= 749) this.resumeAutoplay();
        return;
      }
      this.touchEndX = e.changedTouches[0].clientX;
      this.handleSwipe();
      this.resetTouchValues();
      if (window.innerWidth <= 749) this.resumeAutoplay();
    }

    handleMouseDown(e) {
      if (e.button !== 0) return;
      this.touchStartX = e.clientX;
      this.touchStartY = e.clientY;
      this.isSwiping = false;
      this.container.style.cursor = 'grabbing';
      this.pauseAutoplay();
      e.preventDefault();
    }
    handleMouseMove(e) {
      if (!this.touchStartX) return;
      const diffX = Math.abs(this.touchStartX - e.clientX);
      const diffY = Math.abs(this.touchStartY - e.clientY);
      if (diffX > diffY && diffX > 10) this.isSwiping = true;
    }
    handleMouseUp(e) {
      if (!this.touchStartX || !this.isSwiping) {
        this.container.style.cursor = '';
        if (window.innerWidth <= 749) this.resumeAutoplay();
        return;
      }
      this.touchEndX = e.clientX;
      this.handleSwipe();
      this.resetTouchValues();
      this.container.style.cursor = '';
      if (window.innerWidth <= 749) this.resumeAutoplay();
    }

    handleSwipe() {
      const swipeDistance = this.touchStartX - this.touchEndX;
      if (Math.abs(swipeDistance) < this.minSwipeDistance) return;
      if (swipeDistance > 0) this.nextSlide();
      else this.prevSlide();
    }

    resetTouchValues() {
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.touchStartY = 0;
      this.touchEndY = 0;
      this.isSwiping = false;
    }

    goToSlide(index) {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.currentSlide = index;

      if (window.innerWidth <= 749) {
        this.updateMobileCarousel();
        this.dots.forEach(dot => dot.classList.remove('active'));
        if (this.dots[index]) this.dots[index].classList.add('active');
      } else {
        this.slides.forEach(slide => slide.classList.remove('active'));
        this.dots.forEach(dot => dot.classList.remove('active'));
        this.slides[index].classList.add('active');
        if (this.dots[index]) this.dots[index].classList.add('active');
      }

      setTimeout(() => { this.isTransitioning = false; }, 300);
    }

    nextSlide() {
      if (this.isTransitioning) return;
      const totalSlides = window.innerWidth <= 749 ? this.logoData.length : this.slides.length;
      const nextIndex = (this.currentSlide + 1) % totalSlides;
      this.goToSlide(nextIndex);
    }
    prevSlide() {
      if (this.isTransitioning) return;
      const totalSlides = window.innerWidth <= 749 ? this.logoData.length : this.slides.length;
      const prevIndex = (this.currentSlide - 1 + totalSlides) % totalSlides;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      const totalSlides = window.innerWidth <= 749 ? this.logoData.length : this.slides.length;
      if (this.autoplayTimer || totalSlides <= 1) return;
      this.autoplayTimer = setInterval(() => this.nextSlide(), this.autoplayInterval);
    }
    pauseAutoplay() { if (this.autoplayTimer) { clearInterval(this.autoplayTimer); this.autoplayTimer = null; } }
    resumeAutoplay() {
      const totalSlides = window.innerWidth <= 749 ? this.logoData.length : this.slides.length;
      if (!this.autoplayTimer && window.innerWidth <= 749 && totalSlides > 1) this.startAutoplay();
    }
    resetAutoplay() { this.pauseAutoplay(); if (window.innerWidth <= 749) this.startAutoplay(); }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.testimonial-logos').forEach(container => new TestimonialLogos(container));
  });

  } catch(e) { console.error(e); }
})();
})();
